import React from "react";
import Layout from "../Shared/Layout";

const AideClient = () =>{
    return(
        <>

           <Layout>
                <div class="content-body default-height">

                        <div className="container-fluid">
                            <div className="row">

                                <div className="col-xl-12">
                                    <div className="page-titles">
                                        <nav style={{"--bs-breadcrumb-divider":" '>';"}} aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item text-primary">Aides</li>
                                            </ol>
                                        </nav>

                                    </div>
                                </div>
                                
                                {/* <!-- Section FAQ --> */}
                                <section className="faq-section mb-5">
                                    <h2 className="mb-4">Questions Fréquemment Posées (FAQ)</h2>
                                    <div className="accordion" id="faqAccordion">
                                    {/* <!-- Question 1 --> */}
                                    <div className="accordion-item faq-item">
                                        <h2 className="accordion-header" id="faqHeading1">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse1" aria-expanded="true" aria-controls="faqCollapse1">
                                            Comment puis-je créer un compte ?
                                        </button>
                                        </h2>
                                        <div id="faqCollapse1" className="accordion-collapse collapse show" aria-labelledby="faqHeading1" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            Pour créer un compte, cliquez sur le bouton s inscrire en haut de la page, remplissez le formulaire avec vos informations personnelles, et validez.
                                        </div>
                                        </div>
                                    </div>
                                    {/* <!-- Question 2 --> */}
                                    <div className="accordion-item faq-item">
                                        <h2 className="accordion-header" id="faqHeading2">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse2" aria-expanded="false" aria-controls="faqCollapse2">
                                            Comment réinitialiser mon mot de passe ?
                                        </button>
                                        </h2>
                                        <div id="faqCollapse2" className="accordion-collapse collapse" aria-labelledby="faqHeading2" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            Cliquez sur Mot de passe oublié sur la page de connexion, entrez votre adresse email, et suivez les instructions envoyées par mail.
                                        </div>
                                        </div>
                                    </div>
                                    {/* <!-- Question 3 --> */}
                                    <div className="accordion-item faq-item">
                                        <h2 className="accordion-header" id="faqHeading3">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse3" aria-expanded="false" aria-controls="faqCollapse3">
                                            Comment contacter le support client ?
                                        </button>
                                        </h2>
                                        <div id="faqCollapse3" className="accordion-collapse collapse" aria-labelledby="faqHeading3" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            Vous pouvez utiliser le formulaire ci-dessous pour contacter notre équipe ou appeler notre support au numéro indiqué dans la section Contact.
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </section>

                            

                                <div className="col-xl-12 col-xxl-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Contactez-Nous</h4>
                                        </div>
                                        <div className="card-body custom-ekeditor">
                                            <div >
                                                <form action="#" method="POST">
                                                    <div className="mb-3">
                                                    <label htmlFor="name" className="form-label">Nom</label>
                                                    <input type="text" className="form-control" id="name" placeholder="Entrez votre nom" required/>
                                                    </div>
                                                    <div className="mb-3">
                                                    <label htmlFor="email" className="form-label">Adresse Email</label>
                                                    <input type="email" className="form-control" id="email" placeholder="Entrez votre adresse email" required/>
                                                    </div>
                                                    <div className="mb-3">
                                                    <label htmlFor="message" className="form-label">Message</label>
                                                    <textarea id="message" className="form-control" rows="5" placeholder="Décrivez votre problème ou posez votre question" required></textarea>
                                                    </div>
                                                    <button type="submit" className="btn btn-primary w-100">Envoyer</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>
           </Layout>
       
        </>
    )
}

export default AideClient;

